module.exports = __webpack_public_path__ + "static/img/member06.f8dc6ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member06.png
// module id = iB3f
// module chunks = 0